import { range } from '@udemy/shared-utils';
import classNames from 'classnames';
import React from 'react';
import { Block } from '../block/block.react-component';
import { Skeleton } from '../skeleton/skeleton.react-component';
import styles from "./text-skeleton.module.css";
/**
 * React component prop interface for the Paragraph component.
 * @internal
 */

/**
 * The Paragraph component. A `<p>` tab with several {@link Block} components rendered.
 * @internal
 */
const Paragraph = _ref => {
  let {
    lineCount,
    justified
  } = _ref;
  return /*#__PURE__*/React.createElement("p", {
    className: classNames({
      [styles['not-justified']]: !justified
    })
  }, range(lineCount).map(i => /*#__PURE__*/React.createElement(Block, {
    key: i,
    className: classNames('ud-text-skeleton-line', styles.line)
  })));
};
/** React component props for the TextSkeleton component. */


/** The TextSkeleton component. Mimics scaffolding for paragraphs of content while loading. */
export const TextSkeleton = _ref2 => {
  let {
    lineCountPerParagraph = 5,
    paragraphCount = 1,
    withTitle,
    justified = false,
    className
  } = _ref2;
  return /*#__PURE__*/React.createElement(Skeleton, {
    className: classNames('ud-text-skeleton', styles['text-skeleton'], className)
  }, withTitle && /*#__PURE__*/React.createElement(Block, {
    className: classNames('ud-text-skeleton-title', styles.title)
  }), range(paragraphCount).map(i => /*#__PURE__*/React.createElement(Paragraph, {
    key: i,
    justified: justified,
    lineCount: lineCountPerParagraph
  })));
};
//# sourceMappingURL=text-skeleton.react-component.js.map